/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Subtitle_PropertyInputs */

const cs_templates_use_picker_subtitle_property = /** @type {(inputs: Templates_Use_Picker_Subtitle_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona se otevře na zvoleném inzerátu, připravená ke generování.`)
};

const en_templates_use_picker_subtitle_property = /** @type {(inputs: Templates_Use_Picker_Subtitle_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The template opens on the selected listing, ready to generate.`)
};

/**
* | output |
* | --- |
* | "The template opens on the selected listing, ready to generate." |
*
* @param {Templates_Use_Picker_Subtitle_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_subtitle_property = /** @type {((inputs?: Templates_Use_Picker_Subtitle_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Subtitle_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_subtitle_property(inputs)
	return cs_templates_use_picker_subtitle_property(inputs)
});